import { HubFeature } from '@ats/api/cm';
import { LocDefs, LocMap, LocPortal, MapLocKeys } from '@cm/core/localization';

export type SpLocalizeModalLocs = 'SPSystemLocalizeModalChangesSaved';
export type CpLocalizeModalLocs = 'CPSystemLocalizeModalChangesSaved';

export const spLocalizeModalLocs: LocDefs<SpLocalizeModalLocs> = {
	SPSystemLocalizeModalChangesSaved: {
		defaultValue: 'Changes Saved',
		displayPath: 'System|Localize Modal|Changes Saved',
		description: 'Notification displayed when changes are saved.',
		displayType: 'Notification',
		feature: HubFeature.Core,
		portal: 'SP' as LocPortal,
		shared: false,
		htmlAllowed: false,
	},
};

export const cpLocalizeModalLocs: LocDefs<CpLocalizeModalLocs> = {
	CPSystemLocalizeModalChangesSaved: {
		defaultValue: 'Changes Saved',
		displayPath: 'System|Localize Modal|Changes Saved',
		description: 'Notification displayed when changes are saved.',
		displayType: 'Notification',
		feature: HubFeature.CandidateAccess,
		portal: 'CP' as LocPortal,
		shared: false,
		htmlAllowed: false,
	},
};

export const LOC_KEYS = MapLocKeys<SpLocalizeModalLocs | CpLocalizeModalLocs>({
	...spLocalizeModalLocs,
	...cpLocalizeModalLocs,
});
export type LocalizeModalLocType = LocMap<SpLocalizeModalLocs | CpLocalizeModalLocs>;
